// constants
import { ITEM_ERROR_CODES } from 'shared/constants/cart';
import { BASE_CART_URL, MOBILE_CHECKOUT_URI, COUPONS_URL } from 'shared/constants/uri';

// defs
import { Cart } from 'shared/types/cart';

// helpers
import { getCartPageLoadData } from 'shared/layouts/Cart/helpers';
import NFA from 'shared/helpers/analytics/NFAnalytics';

export const getGrandTotal = (cart?: Cart) => cart?.cartPriceDTO?.grandTotal || 0;

export const getFreeItems = (cart?: Cart) => cart?.freeItems || [];

export const getProducts = (cart?: Cart) => cart?.items || [];

export const getPaymentDetails = (cart?: Cart) => cart?.cartTotal;

export const getCartItemCounts = (cart?: Cart) => cart?.itemCount || 0;

export const getCartItemQuantity = (cart?: Cart) => cart?.quantity || 0;

export const getOOSItems = (cart?: Cart) =>
  [...(cart?.freeItems || []), ...(cart?.freeSamples || []), ...(cart?.items || [])].filter(
    (item) => item.isOutOfStock
  );

export const getInSufficientQtyItems = (cart?: Cart) =>
  (cart?.items || []).filter(
    (item) =>
      item.error !== undefined &&
      item.error.errorCode === ITEM_ERROR_CODES.INSUFFICIENT_QTY_IN_STOCK
  );

export const getShippingMessage = (cart?: Cart) => cart?.shippingDataDTO?.shippingText;

export const getShippingCommunicationText = (cart?: Cart) =>
  cart?.shippingDataDTO?.communicationText;

export const getCouponCode = (cart?: Cart) => cart?.couponCode;

export const getCouponDiscount = (cart?: Cart) => cart?.cartTotal?.couponDiscount || {};

export const getAddress = (cart?: Cart) => cart?.address;

export const getAddressErrorMessage = (cart?: Cart) => cart?.address?.error?.errorMessage;

export const getCartErrorMessage = (cart?: Cart) => cart?.cartError?.errorMessage;

export const hasErrorMessage = (cart?: Cart) => cart?.cartError?.errorMessage !== undefined;

export const isCartContinueEnabled = (cart?: Cart) => {
  if (cart === undefined) {
    return false;
  }

  if (getInSufficientQtyItems(cart).length > 0) {
    return false;
  }

  if (
    hasErrorMessage(cart) &&
    (cart.cartFlagDTO.isCheckoutAllowed === false || cart.cartFlagDTO.isOrderAllowed === false)
  ) {
    return false;
  }

  return true;
};

export const isAddressContinueEnabled = (cart?: Cart) => cart?.address?.error === undefined;

export const getCartInfoMessage = (cart?: Cart) => cart?.infoMessageDTO?.infoText;

export const getCartAppliedOffersDetails = (cart?: Cart) => cart?.appliedOfferLabelDetails || [];

export const getRewardsDTO = (cart?: Cart) => cart?.rewardsDTO || {};

const SERVICEABILITY_ENABLED_ROUTE = [BASE_CART_URL, MOBILE_CHECKOUT_URI, COUPONS_URL];

export const shouldPincodeToCartRefresh = (pathname: string) =>
  SERVICEABILITY_ENABLED_ROUTE.includes(pathname);

export const updateCartDataOnDatalayer = (cart?: Cart) =>
  NFA.updateDataLayer(getCartPageLoadData(cart));

export const getConvenienceChargesData = (cart?: Cart) =>
  cart?.shippingDataDTO?.convenienceChargesDTO || [];

export const getFomoTag = (cart?: Cart) => cart?.fomoTagDTO || {};

export const getFreeGiftsBannerData = (cart?: Cart) => cart?.freeGiftsBannerData || {};

export const getFreeSamples = (cart?: Cart) => cart?.freeSamples || [];

export const getOOSFreeItems = (cart?: Cart) =>
  [...(cart?.freeItems || []), ...(cart?.freeSamples || [])].filter((item) => item.isOutOfStock);
